var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("customer::customer-list::tagRule"),
        visible: _vm.visible,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "label-title" },
          [
            _vm._v(
              " " + _vm._s(_vm.$t("customer::customer-list::tagAttr")) + " "
            ),
            _c(
              "el-tooltip",
              {
                attrs: {
                  placement: "right",
                  content: _vm.$t("customer::customer-list::tagTips"),
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-question",
                  staticStyle: { color: "#999" },
                }),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _vm._v(
              " " + _vm._s(_vm.$t("customer::customer-list::exceed")) + " "
            ),
            _c("el-input-number", {
              staticClass: "input-wrap",
              attrs: { precision: 0, controls: false },
              on: { blur: _vm.onBlur },
              model: {
                value: _vm.form.lostValue,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "lostValue", $$v)
                },
                expression: "form.lostValue",
              },
            }),
            _vm._v(
              " " + _vm._s(_vm.$t("customer::customer-list::exceedDays")) + " "
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }